module.exports = __webpack_public_path__ + "img/top3.87f50c8a.jpg";